module.exports = __webpack_public_path__ + "static/img/strong_64.22734f03.png";